import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { _GameNameHorizontalBase as GameNameHorizontalBase } from './cssVar/gameNameHorizontalBase'
import { _GameNameHorizontalDefault as GameNameHorizontalDefault } from './cssVar/gameNameHorizontalDefault'
import { _GameNameHorizontalLarger as GameNameHorizontalLarger } from './cssVar/gameNameHorizontalLarger'
import { _GameNameHorizontalSmall as GameNameHorizontalSmall } from './cssVar/gameNameHorizontalSmall'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { VerticalProps } from '../../components/basePropsConfig'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type GameNameHorizontalCssVarManager =
  GetCssVarManager<GameNameHorizontalBase>
export {
  GameNameHorizontalBase,
  GameNameHorizontalDefault,
  GameNameHorizontalLarger,
  GameNameHorizontalSmall
}
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<GameNameHorizontal>({
  name: 'GameNameHorizontal'
})
export default class GameNameHorizontal extends Mixins<
  BaseCssVarInject<GameNameHorizontalBase>
>(BaseCssVarInject) {
  /** 默认尺寸 */
  public static getCssVarDefault = () => new GameNameHorizontalDefault()
  /** 小号尺寸 */
  public static getCssVarSmall = () => new GameNameHorizontalSmall()
  /** 大号尺寸 */
  public static getCssVarLarger = () => new GameNameHorizontalLarger()

  @Inject() cardProps!: Required<VerticalProps>

  /** 渲染游戏名称 */
  render() {
    const { gameName, logoUrl = '' } = this.cardProps
    return (
      <div
        class={{
          [style['game-name-horizontal']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <my-img
          class={style['left-logo']}
          src={logoUrl}
          options={{ type: 'div' }}
        ></my-img>
        <p class={style['right-name']}>{gameName}</p>
      </div>
    )
  }
}
